import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

import { computed, shallowRef, watch } from 'vue';
import { useRoute } from 'vue-router';
import { can, useTenant } from '@/composables';
import { LAYOUTS } from '@/enum';
import Default from '../Default';
import PublicLayout from '../PublicLayout';
import NotFound from '@/views/Errors/404.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseLayout',
  setup(__props) {

const layout = shallowRef(Default);

const route = useRoute();

const $tenant = useTenant();

const canSee = computed<boolean>(() => (route.meta.permission ? can(route.meta.permission) : true));

const enabledSetting = computed<boolean>(() =>
  route.meta.settings ? $tenant.tenantSettingEnabled(route.meta.settings) : true,
);

watch(
  () => route.meta,
  async (meta) => {
    if (!meta?.layout) {
      layout.value = route.matched[0]?.components?.default;
      return;
    }
    try {
      const component = await import(`@/layouts/${meta.layout}`);
      layout.value = component?.default || Default;
    } catch (e) {
      layout.value = meta.layout === LAYOUTS.DEFAULT ? Default : PublicLayout;
    }
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value), null, {
    default: _withCtx(() => [
      (canSee.value && enabledSetting.value)
        ? _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 0)
        : (_openBlock(), _createBlock(NotFound, { key: 1 }))
    ]),
    _: 3
  }))
}
}

})